import { useEffect } from 'react';

const BLUESKY_EMBED_SCRIPT_URL = 'https://embed.bsky.app/static/embed.js';
const BLUESKY_EMBED_SCRIPT_ATTRIBUTE = 'data-bluesky-embed';

// embed.js declares top-level consts, so a second copy throws "Identifier 'IS_DEV' has already been declared".
export default function BlueskyEmbed({ updateOn }: any) {
  useEffect(() => {
    // biome-ignore lint/suspicious/noExplicitAny: third-party global
    const bluesky = (window as any).bluesky;
    if (bluesky) {
      bluesky.scan();
      return;
    }
    // Still loading: embed.js scans the page itself once it runs.
    if (document.querySelector(`script[${BLUESKY_EMBED_SCRIPT_ATTRIBUTE}]`)) return;

    const script = document.createElement('script');
    script.src = BLUESKY_EMBED_SCRIPT_URL;
    script.setAttribute(BLUESKY_EMBED_SCRIPT_ATTRIBUTE, 'true');
    script.addEventListener('error', () => script.remove());
    document.body.appendChild(script);
  }, [updateOn]);

  return null;
}
